import { client } from "../../../api/client"

const apiURL = process.env.REACT_APP_GENESYS_API_URL

export const fetchUsersData = async () => {
    if (process.env.REACT_APP_USELOCALDATA === "true") { 
        return require('./_local/_usersData.json')
    } else {
        if (process.env.REACT_APP_STATIC_LISTS_API_URL) {
            const response = await client.get(process.env.REACT_APP_STATIC_LISTS_API_URL, '/users')
            return response.data
        } else {
            const response = await client.get(apiURL, '/Stage?entitytype=User')
            return response.data
        }
    }
};

export const fetchQueuesData = async () => {
    if (process.env.REACT_APP_USELOCALDATA === "true") { 
        return require('./_local/_queuesData.json')
    } else {
        if (process.env.REACT_APP_DISABLE_QUEUES === 'true') {
            return []
        }
        const response = await client.get(apiURL, '/Stage?entitytype=Queue')
        return response.data
    }
};

export const fetchWrapUpCodesData = async () => {
    if (process.env.REACT_APP_USELOCALDATA === "true") { 
        return require('./_local/_wrapUpCodesData.json')
    } else {
        if (process.env.REACT_APP_STATIC_LISTS_API_URL) {
            return []
        } else {
            const response = await client.get(apiURL, '/Stage?entitytype=WrapupCode')
            return response.data
        }
    }
};
